export const SEARCH_TOKENS_QUERY = /* GraphQL */ `
  query SearchTokens(
    $collectionName: String!
    $word: String!
    $objectType: String
    $limit: Int
    $nextToken: String
  ) {
    searchTokens(
      collectionName: $collectionName
      word: $word
      objectType: $objectType
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        objectID
        objectType
        label
        number
      }
      nextToken
    }
  }
`;
